export default __webpack_public_path__ + "static/media/6.7282fd93.webp";